import React from 'react'
import _ from 'lodash/fp'
import { useMutation } from 'react-apollo'
import gql from 'graphql-tag'

import Button from './Button'
import apolloClient from '../../../apollo'

import { RETURN_PATH } from '../../../config'
// const RETURN_PATH = 'http://glfr.mlg.test/connect/' // FIXME

const initGolfboxAuthMutation = gql`
mutation initGolfboxAuthMutation($union: GBUnion!, $returnTo: String!) {
  initGolfboxOauth(union: $union, returnTo: $returnTo)
}
`
const GolfboxLogin = ({ label = 'Continue with GolfBox', buttonColor, icon, ...props }) => {
  const [getOauthUrl] = useMutation(initGolfboxAuthMutation, { client: apolloClient })

  const onClick = async () => {
    const { data: { initGolfboxOauth: url } } = await getOauthUrl({
      variables: {
        union: _.toUpper(props.union),
        returnTo: `${RETURN_PATH}/connect/`
      }
    })
    if (url) {
      window.location = url
    }
  }

  return (
    <Button
      onClick={onClick}
      buttonColor={buttonColor}
      icon={icon}

    >
      {label}
    </Button>
  )
}

export default GolfboxLogin
const dguConfig = {
  union: 'dgu',
  label: 'Continue with Dansk Golf Union',
  icon: <img style={{ height: 24 }} src={`${RETURN_PATH}/static/media/dgu_logo.png`} />,
  buttonColor: 'rgba(19,82,48, 1.0)'
}
const golfisConfig = {
  union: 'golfis',
  label: 'Continue with Golfsamband Islands',
  icon: <img style={{ height: 24 }} src={`${RETURN_PATH}/static/media/golfis_logo.png`} />,
  buttonColor: '#003566'
}
export const DGULogin = props => GolfboxLogin({ ...dguConfig, ...props })
export const GolfisLogin = props => GolfboxLogin({ ...golfisConfig, ...props })
